<template>
    <v-container fluid>
      <h2 class="subheading grey--text">{{$t('automatic_invitation')}}</h2>
      <!-- Diálogo modal Persistente para seleccionar la Caseta -->
      <v-dialog v-model="dialog_inicio" persistent max-width="400px">
        <v-form @submit.prevent="set_caseta()">
          <v-card class="justify-center">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('selecciona_caseta')}}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-autocomplete
                  v-model="caseta"
                  name="caseta"
                  :items="casetas"
                  item-text="nombre"
                  item-value="id"
                  :label="$t('Casetas')"
              ></v-autocomplete>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                  color="primary"
                  type="submit"
              >{{ $t('aceptar') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="dialog_cellphone" max-width="290">
        <v-card>
          <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
          <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog_cellphone = false">{{$t('aceptar')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-layout calign-center justify-center fill-height>
        <v-card width="700" class="mx-auto elevation-7">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              {{$t('automatic_invitation')}}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout  row wrap>
              <v-flex xs12 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                <v-flex xs12>
                  <v-autocomplete
                      autofocus
                      v-model="id_empleado"
                      prepend-icon="person"
                      name="id_empleado"
                      :item-text="example"
                      item-value="id"
                      :label="$t('Empleado')"
                      :filter="customFilter"
                      :error-messages="errores.host"
                      :items="empleados"
                      :no-data-text="$t('no_resultados')"
                      clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                      v-model="id_area"
                      prepend-icon="location_city"
                      name="id_area"
                      item-text="nombre"
                      item-value="id"
                      :label="$t('Area')"
                      :filter="customFilterArea"
                      :error-messages="errores.areaId"
                      :items="areas"
                      :no-data-text="$t('no_resultados')"
                      clearable
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <vue-phone-number-input
                      :only-countries="['MX']"
                      default-country-code="MX"
                      color="#D32F2F"
                      valid-color="#2196F3"
                      @update="onChange"
                      v-model="celular"
                      :translations="custom_cell_phone"
                  >
                  </vue-phone-number-input>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-menu
                        v-model="modal2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="dateInv"
                            :label="$t('fecha_inv')"
                            prepend-icon="event"
                            :error-messages="errores.dateInv"
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateInv"
                          :min="get_current_date()"
                          :locale="$t('region')"
                          @input="modal2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="hora"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="hora"
                            :label="$t('hora_inv')"
                            prepend-icon="access_time"
                            :error-messages="errores.timeInv"
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="menu2"
                          v-model="hora"
                          format="24hr"
                          full-width
                          @click:minute="$refs.menu.save(hora)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-textarea
                        disabled
                        v-model="subject"
                        prepend-icon="subject"
                        name="subject"
                        :placeholder="$t('placeholder_asunto')"
                        :label="$t('Asunto')"
                        :counter="150"
                        :maxlength="150"
                        :error-messages="errores.subject"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-label>{{ $t('mensaje_vehiculo') }}</v-label>
                    <v-radio-group
                        v-model="vehicle"
                        prepend-icon="directions_car"
                        name="vehicle"
                        :mandatory="false"
                        :error-messages="errores.vehicle"
                    >
                      <v-radio :label="$t('Si')" value=true></v-radio>
                      <v-radio label="No" value=false></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-alert
                    :value=alerta
                    type="warning"
                    outline
                    transition="scale-transition"
                >
                  Fallo con el Servidor
                </v-alert>
              </v-flex>
            </v-layout>
            <div align="center">
              <v-btn
                  large
                  color="primary"
                  @click="automatic_invitation()"
                  :loading="loading"
              >{{$t('enviar')}}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
</template>

<script>
    import '@/plugins/axios'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import store from '@/store'
    import Vue from 'vue'
    import { mapState } from 'vuex'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)
    Vue.component('vue-phone-number-input', VuePhoneNumberInput)


    export default {
        name: "automatic_invitation",
        data() {
            return {
                id_empleado: '',
                id_area: '',
                celular:'',
                subject: 'Invitacion generada desde Caseta.',
                vehicle: 'false',
                errores: [],
                areas: [],
                empleados: [],
                loading: false,
                alerta: '',
                dialog_inicio: false,
                casetas: [],
                custom_cell_phone: { },
                band_cellphone: false,
                dialog_cellphone: false,
                cellphone_plus_country_code: '',
                modal2: false,
                menu2: false,
                hora: '',
                dateInv: '',
                caseta: 0
            };
        },
        beforeUpdate() {
            this.custom_cell_phone ={
                "countrySelectorLabel": this.$t('codigo_pais'),
                "phoneNumberLabel": this.$t('celular_invitado'),
                "example": this.$t('ejemplo')
            },
            this.subject = this.$t('msg_automatic_subject')
        },
        computed: {
            ...mapState(['language']),
            device () {
                return this.devices.find(n => n.deviceId === this.deviceId)
            }
        },
        created: function(){
            this.getUsersCompany()
            this.get_areas()
            this.get_casetas()
            if(localStorage.getItem('id_caseta') === null){
                this.dialog_inicio = true
            }
            this.dateInv = this.get_current_date()
        },
        methods: {
          get_current_date: function (){
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1;
            var yyyy = today.getFullYear();

            if(dd<10)
            {
              dd='0'+dd;
            }

            if(mm<10)
            {
              mm='0'+mm;
            }
            today = yyyy + '-' + mm + '-' + dd;
            return today
          },
            onChange (data) {
                console.log(data)
                this.cellphone_plus_country_code = data.e164
                this.band_cellphone = data.isValid
            },
            automatic_invitation () {
              if (this.band_cellphone === true) {
                this.loading = true
                this.errores = []
                let guests = []
                guests.push(
                    {
                      "email": null,
                      "cellphone": this.cellphone_plus_country_code
                    }
                )
                const config = {
                  method: 'post',
                  url: 'https://empresa-service.intrare.app/create_inv/',
                  headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken,
                    'Accept-Language': this.language,
                  },
                  data:{
                    guests: guests,
                    host: this.id_empleado,
                    areaId: this.id_area,
                    dateInv: this.dateInv,
                    timeInv: this.hora,
                    subject: this.subject,
                    vehicle: this.vehicle,
                    notes: '',
                    companyFrom: '',
                    exp: this.dateInv,
                    expiration: this.dateInv,
                    diary: '',
                    typeInv: 0
                  }
                };
                axios(config)
                    .then(ok => {
                      this.loading = false
                      this.$store.commit('snackbar_activate_true')
                      this.$store.commit('snackbar_change_color', 'success')
                      this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                      setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                      this.loading = false
                      if (error.response && error.response.status == 400
                          && typeof error.response.data == "object"
                          && error.response.data)
                        this.errores = error.response.data
                      else if (error.response.status == 404) {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', 'Token Inválido')
                        setTimeout(this.clear, 3000)
                      }
                    })
                    .finally(() => (this.loading = false))
              } else {
                this.dialog_cellphone = true
              }
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
                this.clean_fields()
            },
            clean_fields(){
                this.id_empleado = ''
                this.id_area = ''
                this.celular = ''
                this.hora = ''
            },
            get_areas: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/areas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.areas = response.data

                        console.log(this.id_empresa)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            getUsersCompany: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/usuarios/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empleados = response.data
                        console.log(this.empleados)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            customFilterArea (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            customFilter (item, queryText) {
                const textOne = item.first_name.toLowerCase()
                const textTwo = item.last_name.toLowerCase()
                const textThree = item.email.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
                    || textTwo.indexOf(searchText) > -1
                    || textThree.indexOf(searchText) > -1

            },
            example: item => item.first_name + ' ' + item.last_name +' - ' + item.email,
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    this.dialog_inicio = false
                }
            },
            get_casetas: function(){
                this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                    .then(response => {
                        // Manejar múltiples formatos de respuesta
                        if (response && response.casetas && Array.isArray(response.casetas)) {
                            this.casetas = response.casetas
                        } else if (Array.isArray(response)) {
                            this.casetas = response
                        } else if (response && response.data && Array.isArray(response.data)) {
                            this.casetas = response.data
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    };
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
